module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"reviews_count":"리뷰 %{count}개","review_description":"{percentage}가 <b>{score}</b> 라고 평가했습니다."}}')
  delete Component.options._Ctor
}
